import * as yup from 'yup'

const AdminPlanFormScheme = {
  space: yup.object().shape({
    space: yup.string().required('errors.form.empty'),
  }),
  map: yup.object().shape({
    map: yup.object().required('errors.form.empty'),
  }),
}

const AdminPlanFormFields: { [key in AdminPlanStep]: (keyof AdminPlanForm)[] } = {
  space: ['space'],
  map: ['map'],
}

export { AdminPlanFormScheme, AdminPlanFormFields }
